
<nz-page-header class="site-page-header" nzTitle=" Scheduled Campaign "></nz-page-header>
<div class="" nz-flex nzJustify="flex-end" style="float: right; margin-right: 20px;">
  <nz-breadcrumb [nzAutoGenerate]="true" nzSeparator=">"  >
    <nz-breadcrumb-item>
      <a [routerLink]="['']"> <span nz-icon nzType="appstore" nzTheme="outline"></span></a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <a [routerLink]="[' ']"> <span nz-icon nzType="user-add" nzTheme="outline"></span></a>
    </nz-breadcrumb-item>
  </nz-breadcrumb>
</div>


<nz-card style="width: 100%; margin-top: 1.5rem; ">  
   <h5 nz-typography>Filters</h5>
    <form action="" nz-row nzGutter="32 " nzAlign="bottom">
       <nz-form-item nz-col [nzSpan]="6" class="ml">
           
           <nz-form-control>
               <label for="Expiry">Select Range*</label>
               <nz-range-picker ></nz-range-picker>
           </nz-form-control>
       </nz-form-item>

       <nz-form-item nz-col [nzSpan]="6" class="mt" >
           <button nz-button nzType="primary" class="btn-gap">Submit</button>
           
       </nz-form-item>
   
    </form>
 
   <nz-table
   nzShowSizeChanger
   [nzTotal]="total"
   [nzPageSize]="pageSize"
   [nzPageIndex]="pageIndex"
 >
   <thead>
     <tr>
       <th nzColumnKey="summaryDate" [nzSortFn]="true">Campaign Type</th>
       <th nzColumnKey="totalRequested" [nzSortFn]="true">Campaign Name</th>
       <th nzColumnKey="totalRejected" [nzSortFn]="true">Scheduled Date/Time </th>
       <th nzColumnKey="totalSubmit" [nzSortFn]="true"> Sender Id </th>
       <th nzColumnKey="totalRequested" [nzSortFn]="true">  Message Text  </th>
       <th nzColumnKey="totalFailed" [nzSortFn]="true">  Message Count </th>
       <th nzColumnKey="totalAwaited" [nzSortFn]="true">  Action </th>
     </tr>
   </thead>
   <tbody>
     
   </tbody>
 </nz-table>
   <!-- <router-outlet/> -->
 </nz-card>